export const ForgotPasswordStyle = theme => ({
	paper: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		padding: `${theme.spacing.unit * 2}px ${theme.spacing.unit * 3}px ${theme
			.spacing.unit * 3}px`,
	},
	avatar: {
		margin: theme.spacing.unit,
		backgroundColor: theme.palette.secondary.main,
	},
	form: {
		width: 400, // Fix IE 11 issue.
		marginTop: theme.spacing.unit,
	},
	formMobile: {
		width: "100%",
		marginTop: theme.spacing.unit,
	},
	submit: {
		marginTop: theme.spacing.unit * 2,
	},
	typographytitle: { marginTop: theme.spacing.unit * 3 },
	root: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap",
	},
	wrapper: {
		position: "relative",
		width: "100%",
	},
	buttonProgress: {
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -4,
		marginLeft: -12,
	},
})
